import { useState } from "react";
import CatSelect from "../../cat/CatSelect";
import { TabPanel, TabView } from "primereact/tabview";
import { itemTypes } from "../../common/const";
import { Form } from "../../common/Form";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import Utils from "../../common/Utils";
import { RadioButton } from "primereact/radiobutton";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";


export function CondInput({c,onChange})
{
    console.log("CondInput:"+JSON.stringify(c));
    var input=<InputText disabled className="flex-none"/>;
    if(c.field!=undefined && c.field.fieldType == 'STRING')
        input=<InputText className="flex-none" value={c.value} onChange={onChange}/>;
    if(c.field!=undefined && (c.field.fieldType == 'INT' || c.field.fieldType == 'DEC'))
        input=<InputNumber className="flex-none" value={c.value} onChange={onChange}/>;
    if(c.field!=undefined && c.field.fieldType == 'DATE')
        input=<Calendar className="flex-none" value={Utils.dateFromString(c.value)} onChange={onChange} dateFormat="yy-mm-dd"/>;
    return input;
}
export function CrtCond({cond,onChange,onDelete})
{
    const {t}=useTranslation();
    const fields=[
        {label:t('CrtField.difficulty'),name:'difficulty',fieldType:'INT'},
        {label:t('CrtField.timeCreated'),name:'timeCreated',fieldType:'DATE'},
        {label:t('CrtField.timeUsed'),name:'timeUsed',fieldType:'DATE'},
        {label:t('CrtField.usage'),name:'usage',fieldType:'INT'},
        {label:t('CrtField.weight'),name:'weight',fieldType:'DEC'},
        {label:t('CrtField.itemDiscr'),name:'itemDiscr',fieldType:'DEC'},
        {label:t('CrtField.itemDiff'),name:'itemDiff',fieldType:'DEC'},
        {label:t('CrtField.itemQuality'),name:'itemQuality',fieldType:'INT'},
        {label:t('CrtField.usage'),name:'usage',fieldType:'INT'}
    ]
    const operators=[
        {label:t('@Operator.EQ'),value:"EQ",op:"="},
        {label:t('@Operator.NE'),value:"NE",op:"!="},
        {label:t('@Operator.GT'),value:"GT",op:">"},
        {label:t('@Operator.GTE'),value:"GTE",op:">="},
        {label:t('@Operator.LS'),value:"LS",op:"<"},
        {label:t('@Operator.LTE'),value:"LSE",op:"<="}
    ]
    const onOperatorSelect=(e)=>{
        var c={...cond};
        c.operator=e.target.value;
        onChange(c);
    }
    const onFieldSelect=(e)=>{
        var c={...cond};
        c.field=e.target.value;
        c.value=null;
        onChange(c);
    }
    const onInputChange=(e)=>{        
        var c={...cond};
        if(c.field.fieldType == 'DATE')
            c.value=e.value.toISOString().substr(0,10);
        else
            c.value=e.value;
        onChange(c);
    }

    return(
        <div className="flex gap-3 p-1">
            <Dropdown className="flex-none" style={{width:'12em'}} value={cond.field}
                options={fields} optionLabel="label" onChange={(e)=>onFieldSelect(e)}/>
            <Dropdown className="flex-none" style={{width:'5em'}} value={cond.operator} valueTemplate={(op)=>op?op.op:''} 
                options={operators} optionLabel="label" onChange={(e)=>onOperatorSelect(e)} 
                optionValue="value"/>
            <CondInput c={cond} onChange={(e)=>onInputChange(e)}/>
            <Button severity="danger" rounded text aria-label={t('Delete')} icon="pi pi-times" onClick={e=>onDelete(cond)}/>
        </div>
    )
}
export function CrtItemForm({rec,onChange})
{
    const {t}=useTranslation();
    const [item,setItem] = useState({...rec});
    const [conds,setConds] = useState(rec.criteria!=undefined?rec.criteria:[{}]);

    const onSelectCat=(cat)=>{
        var it={...item,catId:cat.id};
        setItem(it);
        onChange({...it,criteria:conds})
    }
    const onValChange=(vals)=>{
        var it={...item,...vals};
        setItem(it);
        onChange({...it,criteria:conds});
    }
    const addCond=(e)=>{
        var c=[...conds,{}];
        setConds(c);
        onChange({...item,criteria:c});
    }
    const condBar=()=>{
        return(
            <><Button label={t("Add_Condition")} onClick={addCond}></Button></>
        )
    }
    const onCondChange=(cond,index,newVal)=>{
        var cs=[...conds];
        cs[index]=newVal;
        setConds(cs);
        onChange({...item,criteria:cs});
    }
    const onDeleteCond=(cond,index)=>{
        var cs=[...conds];
        cs.splice(index,1);
        setConds(cs);
        onChange({...item,criteria:cs});
    }
    const setCatType=(ct)=>{
        let it={...item,catType:ct};
        setItem(it);
    }
    return(
        <>
		<div style={{width:'35rem',height:'30rem'}}>	
            <TabView>
                <TabPanel header={t("Basic_Props")}>
                    <Panel header={t("Category_Type")} className="mt-2 mb-2">
                        <div className="flex flex-wrap gap-3">
                            <div className="flex align-items-center">
                                <RadioButton inputId="catTypeCourse" name="course" value="COURSE" onChange={(e) => setCatType(e.value)} checked={item.catType === 'COURSE'} />
                                <label htmlFor="catTypeCourse" className="ml-2">{t('Course')}</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="catTypeTopic" name="topic" value="TOPIC" onChange={(e) => setCatType(e.value)} checked={item.catType === 'TOPIC'} />
                                <label htmlFor="catTypeTopic" className="ml-2">{t('Topic')}</label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton inputId="catTypeOutcome" name="course" value="OUTCOME" onChange={(e) => setCatType(e.value)} checked={item.catType === 'OUTCOME'} />
                                <label htmlFor="catTypeOutcome" className="ml-2">{t('Outcome')}</label>
                            </div>
                        </div>
                    </Panel>
                    <div className="formgrid grid">
                        <div className="field col-12">
                            <label htmlFor="catSelect">{t('Category')}</label>
                            <CatSelect inputId="catSelect" className="w-full" value={item.catId} onSelect={onSelectCat} catType={item.catType}></CatSelect>
                        </div>
                    </div>

                    <Form id="formid" formData={item} columns="2" onChange={onValChange}
                        fields={[
                            {id:"itemType",ftype:"dropdown",field:"itemType",label:t("Question_Type"),options:itemTypes},
                            {id:"options",ftype:"number",field:"options",label:t("Option_count")},
                            {id:"questions",ftype:"number",field:"questions",label:t("Questions_Required")},
                            {id:"section",ftype:"number",step:1,field:"section",label:t("Section_No")}
                        ]}>
                    </Form>	
                </TabPanel>
                <TabPanel header={t("Conditions")}>
                    <Toolbar start={condBar} className="mb-2"></Toolbar>
                    { conds.map((c,index)=>{return <CrtCond cond={c} onChange={(val)=>onCondChange(c,index,val)} onDelete={c=>onDeleteCond(c,index)}/>}) }
                </TabPanel>
            </TabView>
		</div>
        </>
    )
}
